module.exports = __webpack_public_path__ + "img/ic_pathbar_followroads_on.490254c8.svg";